<template>
  <div class="order-detail-page full-height display-col">
    <full-con :canReturn='canReturn'>
      <div slot="editBreadcrumb">
        <editBreadcrumb :pageTitle="pageTitle"></editBreadcrumb>
      </div>
      <div slot="full">
        <div class="order-detail-container full-height flex1">
          <el-form :model="orderInfo" ref="addForm" :rules="addFormInfo">
            <div class="tabel-container">
              <div class="table-title">订单信息</div>
              <el-row class="table-content">
                <el-col :span="8" class="content">
                  <el-row>
                    <el-col :span="10">NO：</el-col>
                    <el-col :span="14">{{ orderInfo.orderId }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">创建日期：</el-col>
                    <el-col :span="14">{{ orderInfo.orderCreateTime | dateFormatToSecond }}</el-col>
                  </el-row>
                  <!-- <el-row>
                    <el-col :span="10">同捆：</el-col>
                    <el-col :span="14">{{ orderInfo.tongkun }}</el-col>
                  </el-row> -->
                  <el-row>
                    <el-col :span="10">不良处理中数量：</el-col>
                    <el-col :span="14">{{ orderInfo.badCount }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">待装箱数：</el-col>
                    <el-col :span="14">{{ orderInfo.waitBoxCount }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">库位:</el-col>
                    <el-col :span="14">
                      <!--<el-select v-if="editOrderInfo" v-model="orderInfo.configLocatorId" placeholder="请选择" size="small" clearable>
                        <el-option v-for="(item, index) in configLists.locatorConfigList" :key="index" :label="item.name" :value="item.value">
                        </el-option>
                      </el-select>
                      <el-select v-else v-model="orderInfo.configLocatorId" placeholder="请选择" size="small" disabled>
                        <el-option v-for="(item, index) in configLists.locatorConfigList" :key="index" :label="item.name" :value="item.value">
                        </el-option>
                      </el-select>-->
                      <div style="width: 100%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                        <span
                          v-for="(v,i) in orderInfo.oytqcConfigLocatorOrders"
                          :key="i"
                        >
                          {{v.locatorNo}}
                          <span v-if="orderInfo.oytqcConfigLocatorOrders.length > i + 1">,</span>
                        </span>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">采购工作签：</el-col>
                    <el-col :span="14">
                      <el-form-item v-if="editOrderInfo">
                        <el-input size="small" v-model="orderInfo.staffRemark"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.staffRemark }}</span>
                    </el-col>
                  </el-row>
                  <!-- <el-row>
                    <el-col :span="10">箱子类型：</el-col>
                    <el-col :span="14">
                      <el-select
                        v-if="editOrderInfo"
                        v-model="orderInfo.cartonSizeId"
                        placeholder="请选择"
                        size="small"
                        clearable
                      >
                        <el-option
                          v-for="(item,index) in configLists.boxConfigList"
                          :key="index"
                          :label="item.name"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                      <el-select
                        v-else
                        v-model="orderInfo.cartonSizeId"
                        placeholder="请选择"
                        size="small"
                        disabled
                      >
                        <el-option
                          v-for="(item,index) in configLists.boxConfigList"
                          :key="index"
                          :label="item.name"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-row> -->
                  <!-- <el-row>
                    <el-col :span="10">opp袋类型：</el-col>
                    <el-col :span="14">
                      <el-select
                        v-if="editOrderInfo"
                        v-model="orderInfo.oppTypeId"
                        placeholder="请选择"
                        size="small"
                        clearable
                      >
                        <el-option
                          v-for="(item,index) in configLists.oppConfigList"
                          :key="index"
                          :label="item.name"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                      <el-select
                        v-else
                        v-model="orderInfo.oppTypeId"
                        placeholder="请选择"
                        size="small"
                        disabled
                      >
                        <el-option
                          v-for="(item,index) in configLists.oppConfigList"
                          :key="index"
                          :label="item.name"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-row> -->
                  <!-- <el-row>
                    <el-col :span="10">物流公司：</el-col>
                    <el-col :span="14">
                      <el-select
                        v-if="editOrderInfo"
                        v-model="orderInfo.configLogisticsCompanyId"
                        placeholder="请选择"
                        size="small"
                        clearable
                      >
                        <el-option
                          v-for="(item,index) in configLists.logisticsCompanyConfigList"
                          :key="index"
                          :label="item.name"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                      <el-select
                        v-else
                        v-model="orderInfo.configLogisticsCompanyId"
                        placeholder="请选择"
                        size="small"
                        disabled
                      >
                        <el-option
                          v-for="(item,index) in configLists.logisticsCompanyConfigList"
                          :key="index"
                          :label="item.name"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-row> -->
                  <!-- <el-row>
                    <el-col :span="10">国内物流状态：</el-col>
                    <el-col :span="14">{{ orderInfo.cnLogisticsStatus }}</el-col>
                  </el-row> -->
                  <el-row>
                    <el-col :span="10">购买账号：</el-col>
                    <el-col :span="14">
                      <el-select v-model="orderInfo.buyAccountId" placeholder="请选择" size="small" clearable>
                        <el-option v-for="item in buyAcountList" :key="item.id" :label="item.platformType_hanzi" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8" class="content">
                  <el-row>
                    <el-col :span="10">用户ID：</el-col>
                    <el-col :span="14">{{ orderInfo.userName }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">到货日期：</el-col>
                    <el-col :span="14">{{ orderInfo.receiveTime | dateFormatToSecond }}</el-col>
                  </el-row>
                  <!-- <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row> -->
                  <el-row>
                    <el-col :span="10">换货中数量：</el-col>
                    <el-col :span="14">{{ orderInfo.exchangCount }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">退货数：</el-col>
                    <el-col :span="14">{{ orderInfo.refundCount }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">中文产品描述：</el-col>
                    <el-col :span="14">
                      <el-form-item v-if="editOrderInfo">
                        <el-input size="small" v-model="orderInfo.productDesc"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.productDesc }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">检品工作签：</el-col>
                    <el-col :span="14">
                      <el-form-item v-if="editOrderInfo">
                        <el-input size="small" v-model="orderInfo.checkRemark"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.checkRemark }}</span>
                    </el-col>
                  </el-row>
                  <!-- <el-row>
                    <el-col :span="10">抛重：</el-col>
                    <el-col
                      :span="14"
                      class="ipt-container"
                    >
                      <el-form-item v-if="editOrderInfo">
                        <el-input
                          size="small"
                          v-model="orderInfo.throwWeight"
                        ></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.throwWeight }}</span>
                    </el-col>
                  </el-row> -->
                  <!-- <el-row>
                    <el-col :span="10">OPP袋数：</el-col>
                    <el-col :span="14">
                      <el-form-item v-if="editOrderInfo">
                        <el-input
                          size="small"
                          v-model="orderInfo.oppCount"
                        ></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.oppCount }}</span>
                    </el-col>
                  </el-row> -->
                  <!-- <el-row>
                    <el-col :span="10">国际运单号：</el-col>
                    <el-col :span="14">
                      <el-form-item v-if="editOrderInfo">
                        <el-input
                          size="small"
                          v-model="orderInfo.trackingNumberJpn"
                        ></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.trackingNumberJpn }}</span>
                    </el-col>
                  </el-row> -->

                  <el-row>
                    <el-col :span="10">购买订单号：</el-col>
                    <el-col :span="14">
                      <el-form-item v-if="editOrderInfo">
                        <el-input size="small" v-model="orderInfo.buyOrderNumber"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.buyOrderNumber }}</span>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8" class="content">
                  <el-row>
                    <el-col :span="10">订单状态：</el-col>
                    <el-col :span="14">{{ orderInfo.orderStatus | orderStatusFilter }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">发送日期：</el-col>
                    <el-col :span="14">{{ orderInfo.sendTime | dateFormatToSecond }}</el-col>
                  </el-row>
                  <!-- <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row> -->
                  <el-row>
                    <el-col :span="10">补发中数量：</el-col>
                    <el-col :span="14">{{ orderInfo.reissueCount }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">销毁数：</el-col>
                    <el-col :span="14">{{ orderInfo.destroyCount }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">英文产品描述：</el-col>
                    <el-col :span="14">
                      <el-form-item v-if="editOrderInfo">
                        <el-input size="small" v-model="orderInfo.productDescEn"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.productDescEn }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">商品净重：</el-col>
                    <el-col :span="14">
                      <el-input v-if="editOrderInfo" size="small" v-model="orderInfo.netWeight"></el-input>
                      <span v-else> {{ orderInfo.netWeight }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row>
                  <!-- <el-row>
                    <el-col :span="10">实重：</el-col>
                    <el-col :span="14">
                      <el-form-item v-if="editOrderInfo">
                        <el-input
                          size="small"
                          v-model="orderInfo.realWeight"
                        ></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.realWeight }}</span>
                    </el-col>
                  </el-row> -->
                  <!-- <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row> -->
                  <!-- <el-row>
                    <el-col :span="10">国际物流状态：</el-col>
                    <el-col :span="14">{{ orderInfo.sagawaState }}</el-col>
                  </el-row> -->
                  <!-- <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row> -->

                </el-col>
              </el-row>
            </div>
            <div class="tabel-container">
              <div class="table-title">商品信息</div>
              <el-row class="table-content">
                <el-col :span="8" class="content nomove">
                  <el-row>
                    <el-col :span="10">商品链接：</el-col>
                    <el-col :span="14">
                      <el-form-item v-if="editGoodsInfo">
                        <el-input :style="{ width: (addFormInfo.goodsName[0].required ? '90%!important' : '98%!important') }" size="small"
                          v-model="orderInfo.taobaoUrl"></el-input>
                      </el-form-item>
                      <el-tooltip effect="dark" :content="orderInfo.taobaoUrl" placement="top" v-else>
                        <div class="text-overflow">{{ orderInfo.taobaoUrl }}</div>
                      </el-tooltip>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">
                      <font color="red" v-show="addFormInfo.colour[0].required">*</font>
                      颜色：
                    </el-col>
                    <el-col :span="14" class="hidden">
                      <el-form-item prop="colour" v-if="editGoodsInfo">
                        <el-input :style="{ width: (addFormInfo.colour[0].required ? '50%!important' : '100%') }" size="small"
                          v-model="orderInfo.colour"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.colour }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">代为购买：</el-col>
                    <el-col :span="14">
                      <el-select v-if="editOrderInfoAccountNumber" v-model="orderInfo.agentFlag" placeholder="请选择" size="small" clearable
                        :style="{ width: (addFormInfo.goodsName[0].required ? '90%!important' : '92%!important') }">
                        <!-- @change='isAgentChange(orderInfo.agentFlag)' -->
                        <el-option v-for="(item, index) in loadBoxOptions" :key="index" :label="item.name" :value="item.value">
                        </el-option>
                      </el-select>
                      <el-select v-else v-model="orderInfo.agentFlag" placeholder="请选择" size="small" disabled>
                        <!-- @change='isAgentChange(orderInfo.agentFlag)' -->
                        <el-option v-for="(item, index) in loadBoxOptions" :key="index" :label="item.name" :value="item.value">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">
                      <font color="red" v-show="addFormInfo.goodsCount[0].required">*</font>
                      数量:
                    </el-col>
                    <el-col :span="14" class="hidden">
                      <el-form-item prop="goodsCount" v-if="editGoodsInfo">
                        <el-input style="width: 50%!important;" size="small" v-model="orderInfo.goodsCount"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.goodsCount }}</span>
                    </el-col>
                  </el-row>
                  <el-row v-if="orderInfo.orderType==0">
                    <el-col :span="10">ASIN：</el-col>
                    <el-col :span="14">
                      <el-form-item v-if="editGoodsInfo">
                        <el-input :style="{ width: (addFormInfo.goodsName[0].required ? '90%!important' : '98%!important') }" size="small"
                          v-model="orderInfo.asin"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.asin }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">FBA/YFF/ZOZO/RSL：</el-col>
                    <el-col :span="14">
                      <el-select v-if="editGoodsInfo" v-model="orderInfo.orderType" placeholder="请选择" size="small" clearable
                        :style="{ width: (addFormInfo.goodsName[0].required ? '90%!important' : '92%!important') }" @change='isFbaChange(orderInfo.orderType)'>
                        <el-option v-for="(item, index) in fbaOptions" :key="index" :label="item.name" :value="item.value">
                        </el-option>
                      </el-select>
                      <el-select v-else v-model="orderInfo.orderType" placeholder="请选择" size="small" disabled @change='isFbaChange(orderInfo.orderType)'>
                        <el-option v-for="(item, index) in fbaOptions" :key="index" :label="item.name" :value="item.value">
                        </el-option>
                      </el-select>
                      <!-- <span class="small-span" v-if="['1'].includes(orderInfo.orderType)">商品に記載されている（または貼付されている）バーコードの情報を入力してください</span>
                      <span class="small-span" v-if="['0'].includes(orderInfo.orderType)">Amazonに生成したバーコードを入力してください</span>
                      <span class="small-span" v-if="['2','3','4'].includes(orderInfo.orderType)">商品に記載されている（または貼付されている）バーコードの情報を入力してください</span> -->

                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="10">检品选项：</el-col>
                    <el-col :span="14">
                      <el-select multiple v-if="editGoodsInfo" v-model="orderInfo.configCheckProjectArray" placeholder="请选择" size="small" clearable
                        @change="configCheckChanged()">
                        <el-option v-for="(item, index) in configLists.inspectionConfigList" :key="index" :label="item.name" :value="item.value">
                        </el-option>
                      </el-select>
                      <el-select v-else multiple v-model="orderInfo.configCheckProjectArray" placeholder="请选择" size="small" disabled>
                        <el-option v-for="(item, index) in configLists.inspectionConfigList" :key="index" :label="item.name" :value="item.value">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                  <!-- 图片 -->
                  <el-row>
                    <el-col :span="10" style="height: 70px;">图片：</el-col>
                    <el-col :span="14" style="height: 70px;display:flex; overflow: hidden;">
                      <my-upload v-model="orderInfo.pictureUrl" :disabled="!editGoodsInfo" size="mini" :limit="1" accept=".png,.jpg,.jpeg" />
                      <!-- <img @click="imgclick" v-if="orderInfo.pictureUrl && orderInfo.pictureUrl.length > 0"
                        :src="orderInfo.pictureUrl" alt="" style="width: 35px; height: 35px" />
                      <el-upload class="avatar-uploader" action="/" :show-file-list="false" :http-request="uploadImg"
                        accept=".jpg,.png,.jpeg" :limit="1">
                        <el-button v-if="editGoodsInfo && !orderInfo.pictureUrl" class="list-btn btn-blue bt"
                          ref="uploadImg">上传
                        </el-button>
                      </el-upload>
                      <el-button @click="delImg"
                        v-if="editGoodsInfo && orderInfo.pictureUrl && orderInfo.pictureUrl.length > 0"
                        class="list-btn btn-red btnn">删除</el-button> -->
                    </el-col>
                    <!-- <el-col :span="14">
                      <el-form-item v-if="editGoodsInfo">
                        <el-input
                          size="small"
                          v-model="orderInfo.pictureUrl"
                        ></el-input>
                      </el-form-item>
                      <span
                        v-else
                        class="can-click"
                        @click="imgView(orderInfo.pictureUrl)"
                      >{{
                          orderInfo.pictureUrl
                        }}</span>
                    </el-col> -->
                  </el-row>
                  <el-row style="display: flex;">
                    <el-col :span="10" style="height: auto">PDF/AI文件：</el-col>
                    <el-col :span="14" style="height: auto">
                      <el-form-item>
                        <my-upload v-model="orderInfo.pdfAttachment" :disabled="!editGoodsInfo" size="mini" isJson isDelInfo mode="array"
                          :keyObject="{ url: 'url', name: 'name' }" :limit="5" listType="text" class="change-upload-size">
                          <el-button class="avatar-uploader-icon list-btn btn-blue">上传</el-button>
                        </my-upload>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8" class="content l90">

                  <el-row>
                    <el-col :span="10">
                      <font color="red" v-show="addFormInfo.goodsName[0].required">*</font>
                      商品名：
                    </el-col>
                    <el-col :span="14" class="hidden">
                      <el-form-item v-if="editGoodsInfo" prop="goodsName">
                        <el-input :style="{ width: (addFormInfo.goodsName[0].required ? '90%!important' : '98%!important') }" size="small"
                          v-model="orderInfo.goodsName"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.goodsName }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">
                      <font color="red" v-show="addFormInfo.goodsSize[0].required">*</font>
                      尺寸：
                    </el-col>
                    <el-col :span="14" class="hidden">
                      <el-form-item prop="goodsSize" v-if="editGoodsInfo">
                        <el-input size="small" style="width: 50%!important;" v-model="orderInfo.goodsSize"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.goodsSize }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">
                      <!-- <font
                        color="red"
                        v-show="addFormInfo.trackingNumberCn[0].required"
                      >*</font> -->
                      中国运单号：
                    </el-col>
                    <el-col :span="14">
                      <el-form-item prop="trackingNumberCn" v-if="editGoodsInfo">
                        <!-- :disabled='isAgentDisabled' -->
                        <el-input :style="{ width: (addFormInfo.goodsName[0].required ? '88%!important' : '90%!important') }" size="small"
                          v-model="orderInfo.trackingNumberCn"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.trackingNumberCn }}</span>
                    </el-col>

                    <!-- <el-col :span="10">
                      <font
                        color="red"
                        v-if="orderInfo.orderStatus !== '1'"
                      >*</font>
                      中国运单号：
                    </el-col>
                    <el-col :span="14">
                      <el-form-item
                        prop="trackingNumberCn"
                        v-if="editGoodsInfo"
                      >
                        <el-input
                          :style="{width:(addFormInfo.goodsName[0].required?'88%!important':'90%!important')}"
                          size="small"
                          v-model="orderInfo.trackingNumberCn"
                        ></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.trackingNumberCn }}</span>
                    </el-col> -->
                  </el-row>
                  <el-row>
                    <el-col :span="10">
                      <font color="red" v-show="addFormInfo.price[0].required">*</font>
                      价格:
                    </el-col>
                    <el-col :span="14" class="hidden">
                      <el-form-item prop="price" v-if="editGoodsInfo">
                        <el-input style="width: 50%!important;" size="small" v-model="orderInfo.price" type="tel" :maxlength="12"
                          oninput="value=value.replace(/[^\d.]/g,'')"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.price }}</span>
                    </el-col>
                  </el-row>
                  <el-row >
                    <el-col :span="10" style="display: flex;align-items: center;">
                      <font color="red" v-show="addFormInfo.fnsku[0].required">*</font>
                      <div v-if="orderInfo.orderType==2">
                        <p>検品コード※商品</p>
                        <p style="margin-top: -16px">バーコード情報</p>
                      </div>
                      <span v-else>{{ orderInfo.skuLabel }}</span>
                    </el-col>
                    <el-col :span="14">
                      <el-form-item prop="fnsku" v-if="editGoodsInfo">
                        <el-input :disabled='isFbaDisabled' :style="{ width: (addFormInfo.fnsku[0].required ? '90%!important' : '98%!important') }" size="small"
                          v-model="orderInfo.fnsku"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.fnsku }}</span>
                    </el-col>
                    <!-- <el-col :span="10">
                      <font
                        color="red"
                        v-show="addFormInfo.fnsku[0].required"
                      >*</font>
                      FNSKU/ YFF编码/JAN：
                    </el-col>
                    <el-col
                      :span="14"
                      class="hidden"
                    >
                      <el-form-item
                        prop="fnsku"
                        v-if="editGoodsInfo"
                      >
                        <el-input
                          :style="{width:(addFormInfo.fnsku[0].required?'90%!important':'98%!important')}"
                          size="small"
                          v-model="orderInfo.fnsku"
                        ></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.fnsku }}</span>
                    </el-col> -->
                  </el-row>

                  <!-- <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row> -->
                  <el-row>
                    <el-col :span="10">包装意向：</el-col>
                    <el-col :span="14">
                      <el-select v-if="editGoodsInfo" v-model="orderInfo.putIntent" placeholder="请选择" size="small" clearable
                        :style="{ width: (addFormInfo.goodsName[0].required ? '92%!important' : '100%!important') }">
                        <el-option v-for="(item, index) in putIntentOption" :key="index" :label="item.name" :value="item.value">
                        </el-option>
                      </el-select>
                      <el-select v-else v-model="orderInfo.putIntent" placeholder="请选择" size="small" disabled>
                        <el-option v-for="(item, index) in putIntentOption" :key="index" :label="item.name" :value="item.value">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">水洗标模板：</el-col>
                    <el-col :span="14">
                      <el-form-item prop="laundryLabelId" v-if="editGoodsInfo">
                        <el-select v-model="orderInfo.laundryLabelId" placeholder="请选择" size="small" clearable
                          :style="{ width: (addFormInfo.laundryLabelId[0].required ? '92%!important' : '100%!important') }" :disabled="isDisabled">
                          <el-option v-for="(item, index) in this.laundryLabelOption" :key="index" :label="item.name" :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-select v-else v-model="orderInfo.laundryLabelId" placeholder="请选择" size="small" disabled>
                        <el-option v-for="(item, index) in this.laundryLabelOption" :key="index" :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                  <el-row>
                    <!-- <el-col :span="10" style="height:70px"></el-col>
                    <el-col :span="14" style="height:70px"></el-col> -->
                    <el-col :span="10" style="height:70px">用户备注：</el-col>
                    <el-col :span="14" style="height:70px">
                      <el-form-item v-if="editGoodsInfo">
                        <el-input size="small" v-model="orderInfo.customerRemark" disabled></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.customerRemark }}</span>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8" class="content">
                  <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">品番：</el-col>
                    <el-col :span="14">
                      <el-form-item v-if="editGoodsInfo">
                        <el-input :style="{ width: (addFormInfo.goodsName[0].required ? '90%!important' : '98%!important') }" size="small"
                          v-model="orderInfo.goodsNumber"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.goodsNumber }}</span>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="10">
                      <!-- v-show="addFormInfo.chineseFreightFee[0].required" -->
                      <font color="red">*</font>中国运费：
                    </el-col>
                    <el-col :span="14">
                      <el-form-item prop="chineseFreightFee" v-if="editGoodsInfo">
                        <!-- :disabled='!isAgentDisabled' -->
                        <el-input style="width: 50%!important;" size="small" v-model="orderInfo.chineseFreightFee" type="tel" :maxlength="12"
                          oninput="value=value.replace(/[^\d.]/g,'')"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.chineseFreightFee }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">仓库保管：</el-col>
                    <el-col :span="14">
                      <span
                        v-if="orderInfo.warehouseStorageDays != null && orderInfo.orderStatus != '52' && orderInfo.orderStatus != '72' && orderInfo.orderStatus != '84' && orderInfo.checkFinishTime != null">免费保管中：剩余{{
                          orderInfo.warehouseStorageDays }}天</span>
                      <span
                        v-else-if="orderInfo.chargingDays > 0 && orderInfo.orderStatus != '52' && orderInfo.orderStatus != '72' && orderInfo.orderStatus != '84' && orderInfo.categoryPrice != 0 && orderInfo.freeWarehousing == '0'">保管费用：{{
                          orderInfo.categoryPrice }}元(已保管{{ orderInfo.chargingDays }}天)</span>
                      <span v-else></span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">
                      <font color="red" v-show="addFormInfo.goodsNameCus[0].required">*</font>
                      品名：
                    </el-col>
                    <el-col :span="14">
                      <el-form-item prop="goodsNameCus" v-if="editGoodsInfo">
                        <el-input :disabled='isFbaDisabled' :style="{ width: (addFormInfo.goodsNameCus[0].required ? '90%!important' : '98%!important') }"
                          size="small" v-model="orderInfo.goodsNameCus"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.goodsNameCus }}</span>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="10">检品文件：</el-col>
                    <el-col :span="14">
                      <el-form-item>
                        <my-upload :disabled="!editGoodsInfo" size="mini" v-model="orderInfo.inspectionFileUrl" :fileName.sync="orderInfo.inspectionFileName"
                          :limit="1" listType="text">
                          <el-button class="avatar-uploader-icon list-btn btn-blue">上传</el-button>
                        </my-upload>
                        <!-- <el-upload id="video" action="/" :data="aliyunOssToken" :http-request="uploadInspectionVideo">
                          <el-button class="avatar-uploader-icon list-btn btn-blue">上传</el-button>
                        </el-upload> -->
                      </el-form-item>
                      <!-- <span v-else class="can-click"
                        @click="downloadPdf(orderInfo.inspectionFileName, orderInfo.inspectionFileUrl)">{{
                          orderInfo.inspectionFileName }}</span>
                      <el-button v-if="editGoodsInfo && orderInfo.inspectionFileUrl && orderInfo.inspectionFileUrl.length > 0"
                        style="float: right;margin-top: 7px"
                        :style="{ marginRight: (addFormInfo.goodsName[0].required ? '12%!important' : '10%!important') }"
                        class="avatar-uploader-icon list-btn btn-red" @click="delInspectionPdf()">删除
                      </el-button> -->
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10" style="height: 70px"></el-col>
                    <el-col :span="14" style="height: 70px"></el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
            <!--<div class="tabel-container" v-if="orderInfo.checkVideo != null && orderInfo.checkVideo != ''">-->
            <!--  <div class="table-title">检品视频</div>-->
            <!--  <el-row class="check-video">-->
            <!--    <video v-for="video in getVideo(orderInfo.checkVideo)" :src="video" :width="280" :height="150" controls-->
            <!--      controlsList="noplaybackrate" disablepictureinpicture>您的浏览器不支持video标签</video>-->
            <!--  </el-row>-->
            <!--</div>-->
            <!-- <div class="tabel-container">
              <div class="table-title">地址信息</div>
              <el-row class="table-content">
                <el-col
                  :span="6"
                  class="l87 content"
                >
                  <el-row>
                    <el-col :span="10">
                      <font
                        color="red"
                        v-show="addFormInfo.sender[0].required"
                      >*</font>
                      发件人：
                    </el-col>
                    <el-col
                      :span="14"
                      class="hidden"
                    >
                      <el-form-item
                        prop="sender"
                        v-if="editAddressInfo"
                      >
                        <el-input
                          :style="{width:(addFormInfo.sender[0].required?'85%!important':'98%!important')}"
                          size="small"
                          v-model="orderInfo.sender"
                        ></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.sender }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">
                      <font
                        color="red"
                        v-show="addFormInfo.receiver[0].required"
                      >*</font>
                      收件人：
                    </el-col>
                    <el-col
                      :span="14"
                      class="hidden"
                    >
                      <el-form-item
                        prop="receiver"
                        v-if="editAddressInfo"
                      >
                        <el-input
                          :style="{width:(addFormInfo.receiver[0].required?'86%!important':'98%!important')}"
                          size="small"
                          v-model="orderInfo.receiver"
                        ></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.receiver }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">
                      <font
                        color="red"
                        v-show="addFormInfo.zipCode[0].required"
                      >*</font>
                      收件人邮编：
                    </el-col>
                    <el-col
                      :span="14"
                      class="hidden"
                    >
                      <el-form-item
                        prop="zipCode"
                        v-if="editAddressInfo"
                      >
                        <el-input
                          :style="{width:(addFormInfo.zipCode[0].required?'86%!important':'98%!important')}"
                          size="small"
                          v-model="orderInfo.zipCode"
                        ></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.zipCode }}</span>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col
                  :span="6"
                  class="l87 content"
                >
                  <el-row>
                    <el-col :span="10">
                      <font
                        color="red"
                        v-show="addFormInfo.senderPhone[0].required"
                      >*</font>
                      发件人电话：
                    </el-col>
                    <el-col
                      :span="14"
                      class="hidden"
                    >
                      <el-form-item
                        prop="senderPhone"
                        v-if="editAddressInfo"
                      >
                        <el-input
                          :style="{width:(addFormInfo.senderPhone[0].required?'86%!important':'98%!important')}"
                          size="small"
                          v-model="orderInfo.senderPhone"
                        ></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.senderPhone }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">
                      <font
                        color="red"
                        v-show="addFormInfo.receiverPhone[0].required"
                      >*</font>
                      收件人电话：
                    </el-col>
                    <el-col
                      :span="14"
                      class="hidden"
                    >
                      <el-form-item
                        prop="receiverPhone"
                        v-if="editAddressInfo"
                      >
                        <el-input
                          size="small"
                          :style="{width:(addFormInfo.receiverPhone[0].required?'86%!important':'98%!important')}"
                          v-model="orderInfo.receiverPhone"
                        ></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.receiverPhone }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row>
                </el-col>
                <el-col
                  :span="12"
                  class="content l90"
                >
                  <el-row>
                    <el-col :span="10">
                      <font
                        color="red"
                        v-show="addFormInfo.sendAddress[0].required"
                      >*</font>
                      发件人地址：
                    </el-col>
                    <el-col :span="14">
                      <el-form-item
                        prop="sendAddress"
                        v-if="editAddressInfo"
                      >
                        <el-input
                          :style="{width:(addFormInfo.sendAddress[0].required?'90%!important':'98%!important')}"
                          size="small"
                          v-model="orderInfo.sendAddress"
                        ></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.sendAddress }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">
                      <font
                        color="red"
                        v-show="addFormInfo.receiverAddress[0].required"
                      >*</font>
                      收件人地址：
                    </el-col>
                    <el-col :span="14">
                      <el-form-item
                        prop="receiverAddress"
                        v-if="editAddressInfo"
                      >
                        <el-input
                          :style="{width:(addFormInfo.receiverAddress[0].required?'90%!important':'98%!important')}"
                          size="small"
                          v-model="orderInfo.receiverAddress"
                        ></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.receiverAddress }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div> -->
            <div class="tabel-container" v-if="!isEditPage">
              <div class="table-title">收费信息（元，实际收费以账单为准）</div>
              <el-row class="table-content">
                <el-col :span="5" class="content">
                  <!-- <el-row>
                    <el-col :span="10">国际运费：</el-col>
                    <el-col :span="14">{{ orderInfo.internationalFreight }}</el-col>
                  </el-row> -->
                  <!-- <el-row>
                    <el-col :span="10">印刷费：</el-col>
                    <el-col :span="14">{{ orderInfo.printFee }}</el-col>
                  </el-row> -->
                  <el-row>
                    <el-col :span="10">商品费：</el-col>
                    <el-col :span="14">{{ orderInfo.goodsPrice || 0 }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">异常处理费：</el-col>
                    <el-col :span="14">{{ orderInfo.problemHandlingFee || 0 }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">合计：</el-col>
                    <el-col :span="14">{{ orderInfo.totalPrice || 0 }}</el-col>
                  </el-row>
                </el-col>
                <el-col :span="5" class="content">
                  <!-- <el-row>
                    <el-col :span="10">箱费：</el-col>
                    <el-col :span="14">{{ orderInfo.cartonPrice }}</el-col>
                  </el-row> -->
                  <el-row>
                    <el-col :span="10">代购手续费：</el-col>
                    <el-col :span="14">{{ orderInfo.agentServiceFee || 0 }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">退货运费：</el-col>
                    <el-col :span="14">{{ orderInfo.returnFee || 0 }}</el-col>
                  </el-row>
                  <!-- <el-row>
                    <el-col :span="10">退货手续费：</el-col>
                    <el-col :span="14">{{ orderInfo.refundServiceFee }}</el-col>
                  </el-row> -->
                  <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row>
                </el-col>
                <el-col :span="5" class="content">
                  <!-- <el-row>
                    <el-col :span="10">基础检品费：</el-col>
                    <el-col :span="14">{{ orderInfo.basicInspection }}</el-col>
                  </el-row> -->
                  <el-row>
                    <el-col :span="10">中国运费：</el-col>
                    <el-col :span="14">{{ orderInfo.inlandFreight || 0 }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">仓库保管费：</el-col>
                    <el-col :span="14">{{ orderInfo.categoryPrice || 0 }}</el-col>
                  </el-row>
                  <!-- <el-row>
                    <el-col :span="10">销毁手续费：</el-col>
                    <el-col :span="14">{{ orderInfo.destroyServiceFee }}</el-col>
                  </el-row> -->
                  <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row>
                </el-col>
                <el-col :span="5" class="content">
                  <!-- <el-row>
                    <el-col :span="10">opp袋费：</el-col>
                    <el-col :span="14">{{ orderInfo.oppFee }}</el-col>
                  </el-row> -->
                  <el-row>
                    <el-col :span="10">检品费：</el-col>
                    <el-col :span="14">{{ orderInfo.inspectionFee || 0 }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">换回详细检品费：</el-col>
                    <el-col :span="14">{{ orderInfo.exchangeInspectionFee || 0 }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row>
                </el-col>
                <el-col :span="4" class="content">
                  <el-row>
                    <el-col :span="10">标签费：</el-col>
                    <el-col :span="14">{{ orderInfo.labelFee || 0 }}</el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
            <div class="tabel-container" v-if="!isEditPage">
              <div class="table-title">订单日志</div>
              <el-table :data="orderInfo.hisOrderStateLogList" border style="width: 100%">
                <el-table-column prop="souceState" label="操作前状态">
                </el-table-column>
                <el-table-column prop="targetState" label="操作后状态">
                </el-table-column>
                <el-table-column prop="note" label="操作节点">
                </el-table-column>
                <el-table-column prop="content" label="操作详情">
                </el-table-column>
                <el-table-column prop="createUserName" label="操作人ID">
                </el-table-column>
                <el-table-column prop="createUserRealName" label="操作人姓名">
                </el-table-column>
                <el-table-column label="操作时间" width="160">
                  <template v-slot="scope">
                    {{ scope.row.createTime | dateFormatToSecond }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form>
          <div class="save-btn-container" v-if="isEditPage">
            <el-button class="form-btn btn-gray" @click="cancelEditOrder">取 消</el-button>
            <el-button class="form-btn btn-blue" @click="saveEditOrder">提 交</el-button>
          </div>
        </div>
      </div>
    </full-con>
    <el-dialog :visible.sync="ShowImg" @close="ShowImg = false" width="35%">
      <div>
        <img :src="showImgUrl" alt="" width="100%" height="auto">
      </div>
    </el-dialog>
    <!--    图片放大-->
    <el-dialog title="" :visible.sync="visible" width="30%" show-close center>
      <img width="100%" height="auto" :src="orderInfo.pictureUrl" alt="" class="list-image">
      <!--    <img :src="this.$store.state.imgurl" alt="">-->
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import editBreadcrumb from '../../views/layout/components/editBreadCrumb'
export default {
  data () {
    return {
      isDisabled: true,
      isFbaDisabled: true,
      visible: false,
      isAgentDisabled: true,
      canReturn: '1',
      pageTitle: '订单详情',
      putIntentOption: [
        {
          name: '袋装',
          value: '0'
        }, {
          name: '纸箱',
          value: '1'
        }, {
          name: '鞋盒',
          value: '2'
        }, {
          name: '特殊箱子',
          value: '3'
        }],
      laundryLabelOption: [],
      addFormInfo: {
        goodsCount: [
          { required: true, message: '必填', trigger: 'blur' },
          { pattern: /^[0-9]+$/, message: '数量只能填写数字', trigger: 'blur' },
        ],
        colour: [{ required: true, message: '必填', trigger: 'blur' }],
        goodsSize: [{ required: false, message: '必填', trigger: 'blur' }],
        price: [
          { required: true, message: '必填', trigger: 'blur' },
          { pattern: /^\d+(\.\d{0,2})?$/, message: '只能为数字且最多保留小数点后两位', trigger: 'blur' },

        ],
        trackingNumberCn: [{ required: false, message: '必填', trigger: 'blur' }],
        chineseFreightFee: [{ required: true, message: '必填', trigger: 'blur' }],
        fnsku: [
          { required: true, message: '必填', trigger: 'blur' }
          // {pattern:  /^[0-9]+$/, message: '必填', trigger: 'blur'},
        ],
        goodsNameCus: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        goodsName: [{ required: true, message: '必填', trigger: 'blur' }],
        sender: [{ required: false, message: '必填', trigger: 'blur' }],
        senderPhone: [{ required: false, message: '必填', trigger: 'blur' }],
        sendAddress: [{ required: false, message: '必填', trigger: 'blur' }],
        receiver: [{ required: false, message: '必填', trigger: 'blur' }],
        receiverPhone: [{ required: false, message: '必填', trigger: 'blur' }],
        zipCode: [{ required: false, message: '必填', trigger: 'blur' }],
        receiverAddress: [{ required: false, message: '必填', trigger: 'blur' }],
        laundryLabelId: [{ required: true, message: '必填', trigger: 'blur' }],

      },
      orderId: '',
      customerId: '',
      isEditPage: '0',
      orderInfo: {},
      configLists: {
        logisticsCompanyConfigList: [], //快递 id companyName
        inspectionConfigList: [],//标签 nameCd  name
        boxConfigList: [],//装箱
        oppConfigList: [] //opp袋
      },
      buyAcountList: [],
      loadBoxOptions: [{
        name: '是',
        value: '1'
      }, {
        name: '否',
        value: '0'
      }],
      fbaOptions: [{
        name: '否',
        value: '1'
      },
      {
        name: 'FBA',
        value: '0'
      },
      {
        name: 'YFF',
        value: '2'
      },
      {
        name: 'ZOZO',
        value: '3'
      },
      {
        name: 'RSL',
        value: '4'
      }
      ],
      aliyunOssToken: {},
      ShowImg: false,
      showImgUrl: ''
    }
  },
  components: { editBreadcrumb },
  methods: {
    getVideo (str) {
      if (str != null && str.length > 0) {
        return str.split(',')
      }
      return []
    },
    imgclick () {
      this.visible = true
    },
    // 上传图片
    uploadImg (file) {
      let _self = this
      const isJPG = file.file.type === 'image/jpeg' || 'image/jpg' || 'image/png'
      if (!isJPG) {
        _self.$message.error('请上传jpg,jpeg,png格式的图片！')
        return false
      }
      let specialReg = /["<>:;,}{\\/\\|?*]/
      if (specialReg.test(file.name)) {
        _self.$message.error('文件名中不能包含以下字符 ，；：｛｝* 请检查后修改文件名后再上传')
        return false
      }
      let formdata = new FormData()
      formdata.append('file', file.file)
      formdata.append('modular', 'createOrder')
      formdata.append('fileType', '')
      _self.$http.post('aliyun/oss/upload', formdata).then((res) => {
        if (res.data.code == 200) {
          _self.orderInfo.pictureUrl = res.data.data
          _self.$message.success('上传成功')
        } else {
          _self.$message.error('上传失败')
        }
      })
    },
    // 删除
    async delImg () {
      var _this = this
      this.$confirm('确定删除该图片？', {
        confirmButtonText: '提交',
        confirmButtonClass: 'form-btn btn-blue',
        cancelButtonText: '取消',
        cancelButtonClass: 'form-btn btn-gray',
        type: 'warning'
      })
        .then(() => {
          _this.orderInfo.pictureUrl = ''
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    //检品选项
    configCheckChanged () {
      if (this.orderInfo.configCheckProjectArray.length > 0) {
        if (
          this.orderInfo.configCheckProjectArray &&
          this.orderInfo.configCheckProjectArray.indexOf(
            "laundryLabel"
          ) > -1
        ) {
          this.isDisabled = false
          this.addFormInfo.laundryLabelId[0].required = true
        } else {
          this.addFormInfo.laundryLabelId[0].required = false
          this.orderInfo.laundryLabelId = ''
          this.isDisabled = true
        }
      } else {
        this.orderInfo.configCheckProjectArray = ''
        this.addFormInfo.laundryLabelId[0].required = false
        this.orderInfo.laundryLabelId = ''
        this.isDisabled = true
      }
      // if (this.orderInfo.configCheckProjectArray.length > 0) {
      //   if (this.orderInfo.configCheckProjectArray && this.orderInfo.configCheckProjectArray.indexOf('laundryLabel') > -1) {
      //     this.isDisabled = false;
      //   } else {
      //     this.orderInfo.laundryLabelId = '';
      //     this.isDisabled = true;
      //   }
      // } else {
      //   this.addFormInfo.laundryLabelId[0].required = false;
      //   this.orderInfo.laundryLabelId = "";
      //   this.isDisabled = true;
      // }
    },
    delPdf () {
      let _this = this
      this.$confirm('确定删除该文件？', {
        confirmButtonText: "提交",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "取消",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(() => {
        let formdata = new FormData()
        formdata.append('fileUrl', this.orderInfo.pdfUrl)
        this.$http.post('aliyun/oss/delFile', formdata).then(res => {
          if (res.data.code == 200) {
            _this.$message({
              type: 'success',
              message: res.data.message
            })
            _this.orderInfo.pdfName = ""
            _this.orderInfo.pdfUrl = ""
          }
          else {
            _this.$message({
              type: 'error',
              message: res.data.message
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })


    },
    delInspectionPdf () {
      let _this = this
      this.$confirm('确定删除该文件？', {
        confirmButtonText: "提交",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "取消",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(() => {
        let formdata = new FormData()
        formdata.append('fileUrl', this.orderInfo.inspectionFileUrl)
        this.$http.post('aliyun/oss/delFile', formdata).then(res => {
          if (res.data.code == 200) {
            _this.$message({
              type: 'success',
              message: res.data.message
            })
            _this.orderInfo.inspectionFileName = ""
            _this.orderInfo.inspectionFileUrl = ""
          }
          else {
            _this.$message({
              type: 'error',
              message: res.data.message
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })


    },
    downloadPdf (name, url) {
      let formdata = new FormData()
      formdata.append('FileUrl', url)
      formdata.append('FileName', name)
      this.$http({
        url: "aliyun/oss/download",
        method: "post",
        data: formdata,
        responseType: "blob",//关键点
      }).then((res) => {
        //下载文件操作
        const link = document.createElement("a")
        let blob = new Blob([res.data], { type: "" })//生成blob对象
        link.style.display = "none"
        link.href = URL.createObjectURL(blob)
        link.setAttribute("download", name) //下载的文件名以及文件格式
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    imgView (url) {
      this.ShowImg = !this.ShowImg
      this.showImgUrl = url
    },
    //选择是否fba
    isFbaChange (val) {
      var _this = this
      this.$nextTick(function () {
        _this.$refs.addForm.clearValidate()
      })
      if (val == 1) {
        this.addFormInfo.fnsku[0].required = false
        this.addFormInfo.goodsNameCus[0].required = false
        this.isFbaDisabled = true
        this.orderInfo.fnsku = ""
        this.orderInfo.goodsNameCus = ""
      } else {
        this.addFormInfo.fnsku[0].required = true
        this.addFormInfo.goodsNameCus[0].required = true
        this.isFbaDisabled = false
      }
      if (val == 1) {
        this.$set(this.orderInfo, 'skuLabel', 'バーコード')
        this.$set(this.orderInfo, 'skuPlaceolder', '')
      }
      if (val == 0) {
        this.$set(this.orderInfo, 'skuPlaceolder', 'X00000001')
        this.$set(this.orderInfo, 'skuLabel', 'FNSKU')
      }
      if (val == 2) {
        this.$set(this.orderInfo, 'skuPlaceolder', 'hello-red')
        this.$set(this.orderInfo, 'skuLabel', '検品コード※商品バーコード情報')
      }
      if (val == 3) {
        this.$set(this.orderInfo, 'skuPlaceolder', 'ICH123456789')
        this.$set(this.orderInfo, 'skuLabel', 'ZOZOバーコード')
      }
      if (val == 4) {
        this.$set(this.orderInfo, 'skuPlaceolder', '123456789')
        this.$set(this.orderInfo, 'skuLabel', 'RSLバーコード')
      }
    },
    //选择是否代购
    isAgentChange (val) {
      var _this = this
      this.$nextTick(function () {
        _this.$refs.addForm.clearValidate()
      })
      if (val == "0") {
        //fba
        //需要给对象内每个属性动态赋值
        this.addFormInfo.fnsku[0].required = false
        this.addFormInfo.goodsName[0].required = false
        this.addFormInfo.receiverAddress[0].required = false
        this.addFormInfo.trackingNumberCn[0].required = true
        this.addFormInfo.chineseFreightFee[0].required = false
        this.isAgentDisabled = false
        this.orderInfo.chineseFreightFee = 0
      } else {
        this.addFormInfo.fnsku[0].required = false
        this.addFormInfo.goodsName[0].required = false
        this.addFormInfo.trackingNumberCn[0].required = false
        this.addFormInfo.chineseFreightFee[0].required = true
        this.isAgentDisabled = true
        this.orderInfo.trackingNumberCn = ""
      }
    },
    //选择是否fba
    orderTypeChange (val, index) {
      var _this = this
      this.$nextTick(function () {
        _this.$refs.addForm.clearValidate()
      })
      if (val == '0') {
        //fba
        if (index == 1) {
          this.addFormInfo.fnsku[0].required = true
        }
        //需要给对象内每个属性动态赋值
        this.addFormInfo.goodsName[0].required = true
        this.addFormInfo.sender[0].required = false
        this.addFormInfo.senderPhone[0].required = false
        // this.addFormInfo.addFormInfoRules[index].senderPhone[1].validator=checkNone;
        this.addFormInfo.sendAddress[0].required = false
        this.addFormInfo.receiver[0].required = false
        this.addFormInfo.receiverPhone[0].required = false
        // this.addFormInfo.addFormInfoRules[index].receiverPhone[1].validator=checkNone;
        this.addFormInfo.zipCode[0].required = false
        this.addFormInfo.receiverAddress[0].required = false
      } else {
        this.addFormInfo.fnsku[0].required = false
        this.addFormInfo.goodsName[0].required = false
        this.addFormInfo.sender[0].required = true
        this.addFormInfo.senderPhone[0].required = true
        // this.addFormInfo.addFormInfoRules[index].senderPhone[1].validator=checkPhone;
        this.addFormInfo.sendAddress[0].required = true
        this.addFormInfo.receiver[0].required = true
        this.addFormInfo.receiverPhone[0].required = true
        // this.addFormInfo.addFormInfoRules[index].receiverPhone[1].validator=checkPhone;
        this.addFormInfo.zipCode[0].required = true
        this.addFormInfo.receiverAddress[0].required = true
      }
    },
    uploadVideo (file) {
      let _self = this
      const fileSuffix = file.file.name.substring(file.file.name.lastIndexOf(".") + 1).toLowerCase()

      const whiteList = ["pdf", "ai"]

      if (whiteList.indexOf(fileSuffix) === -1) {
        // this.$message.error('上传文件只能是 pdf、ai 格式');
        _self.$message.error('上传文件只能是 pdf、 ai 格式')
        return
      }

      const isLt2M = file.file.size / 1024 / 1024 < 20

      if (!isLt2M) {
        // this.$message.error('上传文件大小不能超过 20MB');
        _self.$message.error('上传文件大小不能超过 20MB')
        return
      }

      let formdata = new FormData()
      formdata.append("file", file.file)
      formdata.append("modular", "OrderDetail")
      formdata.append("type", "")
      _self.$http.post("aliyun/oss/upload", formdata).then((res) => {
        if (res.data.code == 200) {
          _self.orderInfo.pdfUrl = res.data.data
          _self.orderInfo.pdfName =
            res.data.data.split("OrderDetail/")[1]
          _self.$message.success('上传成功')
        }
      })
      // await this.getOssKey();
      // //key就代表文件层级和阿里云上的文件名
      // //         accessKeyId: "LTAI4G7SvxAdnGS3s3f9UA7K"
      // // callback: "eyJjYWxsYmFja0JvZHlUeXBlIjoiYXBwbGljYXRpb24veC13d3ctZm9ybS11cmxlbmNvZGVkIiwiY2FsbGJhY2tVcmwiOiJodHRwOi8vbG9jYWxob3N0OjgwODEvYWxpeXVuL29zcy9jYWxsYmFjayIsImNhbGxiYWNrQm9keSI6ImZpbGVuYW1lPSR7b2JqZWN0fSZzaXplPSR7c2l6ZX0mbWltZVR5cGU9JHttaW1lVHlwZX0maGVpZ2h0PSR7aW1hZ2VJbmZvLmhlaWdodH0md2lkdGg9JHtpbWFnZUluZm8ud2lkdGh9In0="
      // // dir: "test/oytqc/images/20210413"
      // // host: "http://oytqc-oss.oss-cn-qingdao.aliyuncs.com"
      // // policy: "eyJleHBpcmF0aW9uIjoiMjAyMS0wNC0xM1QwMzoxODoyNi44NzBaIiwiY29uZGl0aW9ucyI6W1siY29udGVudC1sZW5ndGgtcmFuZ2UiLDAsMTA0ODU3NjBdLFsic3RhcnRzLXdpdGgiLCIka2V5IiwidGVzdC9veXRxYy9pbWFnZXMvMjAyMTA0MTMiXV19"
      // // signature: "306UKSf9zW+h+dbty+qytCjEY6E="

      // let imgType = file.file.type.split("/")[1];
      // let filename = file.file.name + file.file.size; //md5对图片名称进行加密
      // // let keyValue = "images/" + md5(new Date() + filename) + "." + imgType;
      // // 组装formdata
      // let formdata = new FormData();
      // formdata.append('name', 'order/'+ file.file.name)
      // // formdata.append('key', keyValue)
      // formdata.append('policy', _self.aliyunOssToken.policy)
      // formdata.append('OSSAccessKeyId', _self.aliyunOssToken.accessKeyId)
      // formdata.append('success_action_status', 200)
      // formdata.append('signature', _self.aliyunOssToken.signature)
      // formdata.append('file', file.file)

      // _self.uploadOSS(formdata,_self.aliyunOssToken.host).then(function(res){
      //     // _self.form.cover = _self.aliyunOssToken.host + '/' + keyValue;
      //     _self.$message.success('上传成功');
      //     this.orderInfo.pdfUrl= _self.aliyunOssToken.host + '/order/' + file.file.name;

      // }).catch(function(error){
      //     _self.$message.error('上传失败');
      // })
    },
    uploadInspectionVideo (file) {
      let _self = this
      const fileSuffix = file.file.name.substring(file.file.name.lastIndexOf(".") + 1).toLowerCase()
      const whiteList = ["doc", "docx", "xls", "xlsx", "ppt", "pptx", "pdf", "txt", "jpg", "png", "gif", "jpeg"]
      if (whiteList.indexOf(fileSuffix) === -1) {
        _self.$message.error('上传文件只能是 doc、docx、xls、xlsx、ppt、pptx、pdf、txt、jpg、jpeg、png、gif 格式')
        return
      }
      const isLt2M = file.file.size / 1024 / 1024 < 20
      if (!isLt2M) {
        _self.$message.error('上传文件大小不能超过 20MB')
        return
      }
      let formdata = new FormData()
      formdata.append("file", file.file)
      formdata.append("modular", "OrderDetail")
      formdata.append("fileType", "")
      _self.$http.post("aliyun/oss/upload", formdata).then((res) => {
        if (res.data.code == 200) {
          _self.orderInfo.inspectionFileUrl = res.data.data
          _self.orderInfo.inspectionFileName =
            res.data.data.split("OrderDetail/")[1]
          _self.$message.success('上传成功')
        }
      })
    },
    uploadOSS (formData, url) {
      // const config = {
      //   headers: { "Content-Type": "multipart/form-data;boundary="+new Date().getTime() }
      //   };
      return axios.post(url, formData)
    },
    async getOssKey () {
      const { data: res } = await this.$http.get('aliyun/oss/policy')
      this.aliyunOssToken = res.data
    },
    async getOrderDetail () {
      const { data: res } = await this.$http.get('order/' + this.orderId)
      this.orderInfo = res.data
      if (this.orderInfo.orderStatus === '1') {
        this.addFormInfo.trackingNumberCn[0].required = false
      }
      this.orderTypeChange(res.data.orderType)

      //字符串转数组
      if (this.orderInfo.configCheckProjectArray && this.orderInfo.configCheckProjectArray.length > 0) {
        this.orderInfo.configCheckProjectArray = this.orderInfo.configCheckProjectArray.split(',')
      }
      if (this.orderInfo.configCheckProjectArray && this.orderInfo.configCheckProjectArray.indexOf('laundryLabel') > -1) {
        this.isDisabled = false
        this.addFormInfo.laundryLabelId[0].required = true
      } else {
        this.orderInfo.laundryLabelId = ''
        this.isDisabled = true
        this.addFormInfo.laundryLabelId[0].required = false
      }
      //是否fba初始化
      if (res.data.orderType == 1) {
        this.addFormInfo.fnsku[0].required = false
        this.addFormInfo.goodsNameCus[0].required = false
        this.isFbaDisabled = true
        this.orderInfo.fnsku = ""
        this.orderInfo.goodsNameCus = ""
      } else {
        this.addFormInfo.fnsku[0].required = true
        this.addFormInfo.goodsNameCus[0].required = true
        this.isFbaDisabled = false
      }
      if (res.data.orderType == 1) {
        this.$set(this.orderInfo, 'skuLabel', 'バーコード')
        this.$set(this.orderInfo, 'skuPlaceolder', '')
      }
      if (res.data.orderType == 0) {
        this.$set(this.orderInfo, 'skuPlaceolder', 'X00000001')
        this.$set(this.orderInfo, 'skuLabel', 'FNSKU')
      }
      if (res.data.orderType == 2) {
        this.$set(this.orderInfo, 'skuPlaceolder', 'hello-red')
        this.$set(this.orderInfo, 'skuLabel', '検品コード※商品バーコード情報')
      }
      if (res.data.orderType == 3) {
        this.$set(this.orderInfo, 'skuPlaceolder', 'ICH123456789')
        this.$set(this.orderInfo, 'skuLabel', 'ZOZOバーコード')
      }
      if (res.data.orderType == 4) {
        this.$set(this.orderInfo, 'skuPlaceolder', '123456789')
        this.$set(this.orderInfo, 'skuLabel', 'RSLバーコード')
      }
      //是否代购初始化
      // if (res.data.agentFlag == '0') {
      //   this.addFormInfo.trackingNumberCn[0].required = true;
      //   this.addFormInfo.chineseFreightFee[0].required = false;
      //   this.isAgentDisabled = false;
      //   this.orderInfo.chineseFreightFee = 0;
      // } else {
      //   this.addFormInfo.trackingNumberCn[0].required = false;
      //   this.addFormInfo.chineseFreightFee[0].required = true;
      //   this.isAgentDisabled = true;
      //   this.orderInfo.trackingNumberCn = "";
      // }
    },
    async getLaundryLabel () {
      const { data: res } = await this.$http.get('laundry/label/template/getAllByCustomerId/' + this.customerId)
      this.laundryLabelOption = res.data
    },
    async getConfigLists () {
      const { data: res } = await this.$http.get('order/getOrderInfoConfigList')
      this.configLists = res.data
      //如果客户拥有特殊检品选项，则查询合并
      if (this.orderInfo.inspectOption != null && this.orderInfo.inspectOption != '') {
        const { data: res } = await this.$http.get('/order/getNameList', { params: { inspectOption: this.orderInfo.inspectOption, isPrivate: '1' } })
        if (res.data != null && res.data.length > 0) {
          let inspectionConfigList = res.data.map((item) => {
            return {
              name: item.name,
              value: item.nameCd
            }
          })
          this.configLists.inspectionConfigList = this.configLists.inspectionConfigList.concat(inspectionConfigList)
        }
      }
    },
    async savePost () {
      if (this.orderInfo.configCheckProjectArray && this.orderInfo.configCheckProjectArray.length > 0) {
        this.orderInfo.configCheckProjectArray = this.orderInfo.configCheckProjectArray.join(',')
      }
      const { data: res } = await this.$http.post('order/updateOrderInfo', this.orderInfo)
      if (res.code == 200) {
        this.$message.success(res.message)
        this.$router.push({ name: 'orders', query: { show: true } })
      } else {
        this.$message.error(res.message)
      }
    },
    async getBuyAccountIdList () {
      this.$http.get('cms/configAccountNumber/getAllList').then(res => {
        this.buyAcountList = res.data.data
        this.buyAcountList.map(res => {
          if (res.platformType !== null) {
            switch (res.platformType) {
              case '0':
                return res.platformType_hanzi = '淘宝 -' + res.accountNumber
                break
              case '1':
                return res.platformType_hanzi = '1688 -' + res.accountNumber
                break
              case '2':
                return res.platformType_hanzi = '京东 -' + res.accountNumber
                break
              case '3':
                return res.platformType_hanzi = '拼多多 -' + res.accountNumber
                break
              case null:
                return res.platformType_hanzi = ''
                break

            }
          }
        })
      })
    },
    async cancelEditOrder () {
      await this.getOrderDetail()
      this.$router.go(-1)
    },
    saveEditOrder () {
      var _this = this
      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this.savePost()
        } else {
          _this.$message.error('请检查必填项或填写格式')
        }
      })
    }
  },
  created () {
    this.orderId = this.$route.query.id
    this.customerId = this.$route.query.customerId
    this.isEditPage = this.$route.query.isEdit == '0' ? false : true
    this.getOrderDetail()
    this.getLaundryLabel()
    this.getConfigLists()
    this.getBuyAccountIdList()
  },
  computed: {
    editGoodsInfo () {
      if (this.isEditPage && (this.orderInfo.orderStatus == 1 || this.orderInfo.orderStatus == 12
        || this.orderInfo.orderStatus == 2 || this.orderInfo.orderStatus == 0 || this.orderInfo.orderStatus == 4
        || this.orderInfo.orderStatus == 8)) {
        return true
      } else {
        return false
      }
    },
    editOrderInfo () {
      if (this.isEditPage && (this.orderInfo.orderStatus == 1 || this.orderInfo.orderStatus == 12
        || this.orderInfo.orderStatus == 2 || this.orderInfo.orderStatus == 0 || this.orderInfo.orderStatus == 4
        || this.orderInfo.orderStatus == 8)) {
        return true
      } else {
        return false
      }
    },
    editOrderInfoAccountNumber () {
      if (this.isEditPage &&
        ((this.orderInfo.orderStatus == 1 && this.orderInfo.agentFlag == 1) || (this.orderInfo.orderStatus == 0 && this.orderInfo.agentFlag == 0))) {
        return true
      } else {
        return false
      }
      // return true;
    },
    editAddressInfo () {
      if (this.isEditPage && (this.orderInfo.orderStatus == 0 ||
        this.orderInfo.orderStatus == 1 ||
        this.orderInfo.orderStatus == 2 ||
        this.orderInfo.orderStatus == 4 ||
        this.orderInfo.orderStatus == 8 ||
        this.orderInfo.orderStatus == 12 ||
        this.orderInfo.orderStatus == 16 ||
        this.orderInfo.orderStatus == 24 |
        this.orderInfo.orderStatus == 26 ||
        this.orderInfo.orderStatus == 28 ||
        this.orderInfo.orderStatus == 32 ||
        this.orderInfo.orderStatus == 36 ||
        this.orderInfo.orderStatus == 82 ||
        this.orderInfo.orderStatus == 40 ||
        this.orderInfo.orderStatus == 60 ||
        this.orderInfo.orderStatus == 76)) {
        return true
      } else {
        return false
      }
    }
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-form-item__error {
  top: 17% !important;
  left: 91% !important;
  width: 24px !important;
}

/deep/ .l87 .el-form-item__error {
  left: 87% !important;
}

/deep/ .nomove .el-form-item__error {
  top: 20% !important;
  left: 53% !important;
  width: 48% !important;
}

/deep/ .hidden {
  overflow: hidden !important;
}

.order-detail-container {
  background: #fff;
  padding: 20px;
}

ul,
li {
  list-style: none;
}

.table-title {
  padding: 5px 0;
  text-align: left;
  background: #f1f2f6;
}

.table-content {
  border-right: 1px solid #e5e9f8;
}

.table-content .content .el-col {
  height: 37px;
  line-height: 30px;
  padding: 0 2px;
  border-left: 1px solid #e5e9f8;
  border-bottom: 1px solid #e5e9f8;
  text-align: left;
  // white-space:nowrap;
  // text-overflow:ellipsis;
  overflow: auto;
}

.el-form-item {
  margin-bottom: 0 !important;
}

/deep/ .el-form-item__content {
  line-height: 30px !important;
}

// .table-content .content{
//   padding-bottom: 10px;
// }
.order-detail-page /deep/ .el-input {
  width: 98% !important;
}

.save-btn-container {
  padding-top: 10px;
  padding-right: 10px;
  text-align: right;
}

.btnn {
  margin-top: 6px;
  margin-left: 10px !important;
}

.bt {
  margin-top: 6px;
}

.check-video {
  border: 1px solid #e5e9f8;
  text-align: left;

  video {
    margin: 20px;
  }
}
.change-upload-size /deep/ .my-upload-set-mini {
  width: 100%;
}
.change-upload-size /deep/ .my-upload-set-mini .el-upload-list__item {
  width: 100%;
}
.change-upload-size /deep/ .my-upload-set-mini .el-upload-list__item-name {
  width: auto;
  padding-right: 20px;
}
.text-overflow {
  height: 100%;
  line-height: 37px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
}
.small-span {
  // margin-top: -px;
  font-size: 10px;
  color: red;
  display: flex;
  line-height: 19px;
}
</style>

